import React from 'react';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { observer } from 'mobx-react';

export const LayoutAttibutesComponent = () => {
    const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
    return (
        <>
            <h2 className="slds-text-heading_small slds-m-bottom_x-small">Attribute From Layout</h2>
            {
                fieldObj.behavior &&
                <div className="slds-form-element">
                    <div className="slds-form-element__control slds-m-bottom_medium">
                        <div className="slds-checkbox">
                            <input type="checkbox" readOnly checked name="options" id="checkbox-unique-id-73" value="checkbox-unique-id-73" />
                            <label className="slds-checkbox__label">
                                <span className="slds-checkbox_faux"></span>
                                <span className="slds-form-element__label">{fieldObj.behavior}</span>
                            </label>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export const LayoutAttibutes = observer(LayoutAttibutesComponent);